/** Public Release (2026-10-06), cross-checked 2026-10-30. Index = current level - 1.
 * https://henesys.gg/guides/formulas#exp-table
 * https://meowdb.com/msclassic/guides/exp-table-level-1-to-100 (2026-10-23)
 * Community client-data references, not an official API. Do not extrapolate past 99.
 */
export const GCW_EXP_TABLE_VERSION = 'gcw-20261006-verified-20261030'
export const GCW_EXP_REQUIREMENTS: readonly number[] = [
  15, 34, 57, 92, 135, 372, 560, 840, 1242, 1716,
  2360, 3216, 4200, 5460, 7050, 8840, 11040, 13716, 16680, 20216,
  24402, 28980, 34320, 40512, 47216, 54900, 63666, 73080, 83720, 95700,
  108480, 122760, 138666, 155540, 174216, 194832, 216600, 240500, 266682, 294216,
  324240, 356916, 391160, 428280, 468450, 510420, 555680, 604416, 655200, 709716,
  748608, 789631, 832902, 878545, 926689, 977471, 1031036, 1087536, 1147132, 1209994,
  1276301, 1346242, 1420016, 1497832, 1579913, 1666492, 1757815, 1854143, 1955750, 2062925,
  2175973, 2295216, 2420993, 2553663, 2693603, 2841212, 2996910, 3161140, 3334370, 3517093,
  3709829, 3913127, 4127566, 4353756, 4592341, 4844001, 5109452, 5389449, 5684790, 11938059,
  25069923, 52646838, 110558359, 232172553, 487562361, 1023880958, 2150150011, 4515315023, 9482161548,
]

export function gcwExpRequirement(level: number): number | null {
  return Number.isInteger(level) && level >= 1 && level < 100 ? GCW_EXP_REQUIREMENTS[level - 1]! : null
}
